import React from "react"
import Layout from "../components/Layout"

const NotFoundPage = () => {
  return (
    <Layout>
      <div className="content bg">
        <section className="header-section bg-light">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="header-content">
                  <h1>404 - Page Not Found</h1>
                </div>
                <p>
                  The page you are looking for might have been removed, had its
                  name changed, or is temporarily unavailable.
                </p>
                <a href="/" className="btn">
                  Go to Homepage
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default NotFoundPage
